import React, { useState, useRef } from 'react';
import { CheckCircle, CheckCircle2, AlertCircle, Copy, Trash2, RefreshCw, Loader2, XCircle, ArrowRight, BookOpen, BookText, ShieldCheck, MessageSquare, X, Send } from 'lucide-react';

function App() {
  const [inputText, setInputText] = useState('');
  const [outputText, setOutputText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isCooldown, setIsCooldown] = useState(false);
  const [isPerfect, setIsPerfect] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  const [corrections, setCorrections] = useState([]);
  const [meaning, setMeaning] = useState(''); // ເພີ່ມ State ສຳລັບເກັບຄວາມໝາຍຄຳສັບ
  // === State ສຳລັບຟອມຕິດຕໍ່ ===
  const [feedbackData, setFeedbackData] = useState({ name: '', email: '', message: '' });
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [isSubmittingFeedback, setIsSubmittingFeedback] = useState(false);
  const [feedbackStatus, setFeedbackStatus] = useState(null);

  // === ຟັງຊັນສົ່ງຂໍ້ຄວາມຫາເຈົ້າຂອງເວັບ ===
  const handleFeedbackSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingFeedback(true);
    setFeedbackStatus(null);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          access_key: "402201a8-0728-439c-9c42-c939beb44c88", // ລະຫັດຂອງທ່ານ
          from_name: "ລະບົບແຈ້ງເຕືອນ LaoGrammar", // ບັງຄັບຊື່ຜູ້ສົ່ງໃຫ້ເປັນຊື່ນີ້ຕະຫຼອດ
          subject: "ມີຂໍ້ຄວາມໃໝ່ຈາກຜູ້ໃຊ້ເວັບ LaoGrammar.com",
          "ຊື່ຜູ້ສົ່ງ": feedbackData.name,       // ປ່ຽນຊື່ຕົວປ່ຽນ ເພື່ອບໍ່ໃຫ້ລະບົບຈັບໄປເປັນຫົວອີເມວ
          "ອີເມວ ຫຼື ເບີໂທຕິດຕໍ່ກັບ": feedbackData.email,
          "ຂໍ້ຄວາມແນະນຳ": feedbackData.message
        }),
      });
      const result = await response.json();
      if (result.success) {
        setFeedbackStatus('success');
        setFeedbackData({ name: '', email: '', message: '' });
      } else {
        setFeedbackStatus('error');
      }
    } catch (error) {
      setFeedbackStatus('error');
    } finally {
      setIsSubmittingFeedback(false);
    }
  };
  React.useEffect(() => {
    // ປິດການຄລິກຂວາ
    const handleContextMenu = (e) => e.preventDefault();
    
    // ປິດປຸ່ມ F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
    const handleKeyDown = (e) => {
      if (
        e.keyCode === 123 || 
        (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || 
        (e.ctrlKey && e.keyCode === 85)
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  // ---------------------------------------------------
  const textAreaRef = useRef(null);

  const handleCheck = async () => {
    if (!inputText.trim()) {
      setError('ກະລຸນາປ້ອນຂໍ້ຄວາມ ຫຼື ຄຳສັບທີ່ຕ້ອງການກວດສອບກ່ອນ.');
      return;
    }

    setIsLoading(true);
    setError('');
    setOutputText('');
    setIsPerfect(false);
    setCopied(false);
    setCorrections([]);
    setMeaning(''); // ຣີເຊັດຄວາມໝາຍກ່ອນກວດສອບໃໝ່

    try {
      const url = "/api";

      // ປັບປຸງ System Prompt ໃຫ້ເປັນ Strict Mode ແລະ ຮອງຮັບການຄົ້ນຫາອິນເຕີເນັດ
      // ປັບປຸງ System Prompt: ເອົາຄວາມເຄັ່ງຄັດຂອງກົດ ມາບວກກັບການອະທິບາຍທີ່ເປັນທຳມະຊາດ
      const systemPrompt = `ທ່ານຄືຜູ້ຊ່ຽວຊານ ແລະ ຄູສອນລະດັບສູງດ້ານໄວຍະກອນລາວ.
      ໜ້າທີ່ຂອງທ່ານຄືກວດຈັບຄຳຜິດ, ແກ້ໄຂ ແລະ ອະທິບາຍເຫດຜົນຢ່າງຊັດເຈນທີ່ສຸດ.

      ກົດລະບຽບການກວດສອບ ແລະ ການອະທິບາຍ (ບັງຄັບໃຊ້ຢ່າງເຄັ່ງຄັດ):
      0. ກົດຫຼີກລ້ຽງພາສາໄທ 100% (STRICT NO-THAI RULE):
         - ❌ ຫ້າມໃຊ້ຄຳສັບ, ສຳນວນ ຫຼື ໄວຍະກອນພາສາໄທ ມາອະທິບາຍຄວາມໝາຍເດັດຂາດ! (ເຊັ່ນ: ຫ້າມໃຊ້ "ໂຫຍຫາ", "ບັງເອີນ"). 
         - ຕ້ອງໃຊ້ຄຳລາວແທ້ ຖ້າແປມາຈາກໄທຕ້ອງປ່ຽນເປັນລາວ (ເຊັ່ນ: ໂຫຍຫາ -> ຄິດຮອດຄິດເຖິງຢ່າງແຮງ/ຢາກໄດ້ຫຼາຍ).
      1. ການອະທິບາຍ (Explanation): ຕ້ອງອະທິບາຍດ້ວຍເຫດຜົນທາງໄວຍະກອນ, ການປະສົມສະຫຼະ, ພະຍັນຊະນະ ຫຼື ວັນນະຍຸດ.
         - ❌ ຫ້າມແປເປັນພາສາອັງກິດ ຫຼື ໃສ່ຄຳອັງກິດໃນວົງເລັບເດັດຂາດ.
         - ❌ ຫ້າມໃຊ້ເຄື່ອງໝາຍວົງຢືມຄູ່ (" ") ພາຍໃນຄຳອະທິບາຍເດັດຂາດ! ໃຫ້ໃຊ້ວົງຢືມດ່ຽວ (' ') ແທນເທົ່ານັ້ນ ເພື່ອປ້ອງກັນລະບົບອ່ານຄ່າຜິດພາດ.
         - ✅ ຕົວຢ່າງການອະທິບາຍທີ່ດີ: ຄຳວ່າ 'ຂ້ອຍ' ແມ່ນຄຳແທນນາມບຸລຸດທີ 1, ຕ້ອງໃຊ້ຕົວສະກົດ ຍ (ຍ ຍຸງ) ສະເໝີ.
      2. ກົດ ໃ- / ໄ-: ພາສາລາວມີຄຳທີ່ໃຊ້ ໃ- (ໄມ້ມ້ວນ) ພຽງແຕ່ 20 ຄຳເທົ່ານັ້ນ (ໃຫຍ່, ໃໝ່, ໃຫ້, ໃສ່, ໃສ, ໃບ, ໃຈ, ໃກ້, ໃຜ, ໃຕ້, ໃນ, ໃຊ້, ໃດ, ໃບ້, ໃຝ່, ໃຄ, ໃຍ, ໃໝ, ໃຫຼ, ໃສ້). ຖ້າພົບຄຳອື່ນນອກຈາກນີ້ທີ່ໃຊ້ ໃ- ໃຫ້ແກ້ເປັນ ໄ- (ໄມ້ມາຍ) ທັນທີ ແລະ ອະທິບາຍກົດນີ້. ຕົວຢ່າງ: "ທັນສະໃໝ" ຕ້ອງແກ້ເປັນ "ທັນສະໄໝ".
      3. ກົດ ຍ / ຢ ແລະ ຖ / ທ: ຕ້ອງແຍກແຍະໃຫ້ຖືກຕ້ອງ ເຊັ່ນ "ຍ່າງເລາະ" (ກ້າວຂາ) ກັບ "ຢ່າງ" (ປະເພດ). "ວັດຖຸ" ຕ້ອງໃຊ້ ຖ.
      4. ຕ້ອງແຍກຄຳຜິດອອກມາເປັນຄຳໆ ໃຫ້ຊັດເຈນ ບໍ່ໃຫ້ເອົາມາປົນກັນ.
      5. ກົດໝາຍຄວາມຖືກຕ້ອງອັນດຽວ (Single Source of Truth): ຖ້າພົບຄຳສັບທີ່ຄົນມັກຂຽນຜິດ (ເຊັ່ນ: ອາຊະຍາກຳ/ອາດຊະຍາກຳ) ຕ້ອງເລືອກຄຳທີ່ຖືກຕ້ອງທີ່ສຸດຕາມວັດຈະນານຸກົມພຽງຄຳດຽວສະເໝີ. ຫ້າມອະນຸລົມໃຫ້ຄຳທີ່ຜິດ ຫຼື ຄຳພາສາປາກເດັດຂາດ.
        - ❌ ຫ້າມຕອບວ່າ "ຖືກທັງສອງ" ຫຼື "ໃຊ້ໄດ້ທັງສອງ" ເດັດຂາດ! ຖ້າຜູ້ໃຊ້ພິມປຽບທຽບມາ (ເຊັ່ນ: "ນາຍົກ ຫຼື ນາຍຍົກ") ທ່ານຕ້ອງຟັນທົງເລືອກຄຳທີ່ຖືກຕ້ອງພຽງ "ຄຳດຽວ" ເທົ່ານັ້ນ. ອີກຄຳໜຶ່ງຕ້ອງຖືກຕັດສິນວ່າ "ຜິດ" ທັນທີ.
      6. ກົດໝາຍເຫຼັກສະຫຼະສຽງສັ້ນ-ຍາວ "ະ" ແລະ "າ" (Zero-Tolerance for xະ / xາ confusion):
         - ❌ ຫ້າມອະນຸລົມ ແລະ ຫ້າມຕອບວ່າ "ຖືກທັງສອງ" ເດັດຂາດ! ❌ ພາສາລາວມີຄຳທີ່ຖືກຕ້ອງພຽງແບບດຽວ.
         - ສຳລັບຄຳປະສົມ ແລະ ຄຳຢືມປາລີ-ສັນສະກິດທຸກຄຳ (ເຊັ່ນ: ກຳມະການ, ວັດທະນະທຳ, ໂພຊະນາການ, ສາທາລະນະ, ພັດທະນາ, ພາລະກິດ, ອິດສະຫຼະ, ໂທລະສັບ): ຕ້ອງເຊື່ອມຄຳດ້ວຍ **ສະຫຼະ "ະ" (ສຽງສັ້ນ)** ເທົ່ານັ້ນ!
         - ຖ້າຜູ້ໃຊ້ພິມຜິດໂດຍການໃຊ້ສະຫຼະ "າ" (ເຊັ່ນ: ກຳມາການ, ວັດທະນາທຳ, ໂພຊານາການ, ສາທາລານະ, ພັດທານາ, ພາລາການ, ໂທລາສັບ): ທ່ານຕ້ອງຈັບຜິດທັນທີ! ຫ້າມປ່ອຍຜ່ານ, ຕ້ອງຕອບ status: "CORRECTED", ແລະ ແກ້ໄຂໃຫ້ກັບມາເປັນສະຫຼະ "ະ" ສະເໝີ.
         - ຖ້າຜູ້ໃຊ້ພິມມາປຽບທຽບກັນ (ເຊັ່ນ: "ກຳມະການ ຫຼື ກຳມາການ ອັນໃດຖືກ") ທ່ານຕ້ອງຟັນທຸງເລືອກຄຳທີ່ໃຊ້ສະຫຼະ "ະ" ເທົ່ານັ້ນ ແລະ ບອກວ່າອີກຄຳໜຶ່ງຜິດ. ຫ້າມໂລເລເດັດຂາດ.
      7. ສູດວິເຄາະສຽງພະຍັນຊະນະຄູ່ທີ່ຄ້າຍກັນ (Phonetic Disambiguation Formula):
         - ຫ້າມຕັດສິນຈາກຄວາມລຶ້ງເຄີຍໃນອິນເຕີເນັດ ແຕ່ໃຫ້ຕັດສິນຈາກ "ຮາກສັບ (Root Word)" ຕາມວັດຈະນານຸກົມກະຊວງສຶກສາທິການເທົ່ານັ້ນ.
         - ສ/ຊ: ຖ້າຮາກສັບເດີມເປັນຕົວ ຊ (ເຊັ່ນ: ໂພຊະນາການ, ອາຊະຍາກຳ) ຫ້າມອະນຸລົມໃຫ້ໃຊ້ ສ (ໂພສະນາການ) ເດັດຂາດ.
         - ຖ/ທ, ຜ/ຝ, ພ/ຟ: ຕ້ອງແຍກຄວາມໝາຍໃຫ້ຂາດຕົວ (ເຊັ່ນ: ວັດຖຸ ໃຊ້ ຖ, ພັດທະນາ ໃຊ້ ທ).
         - ຍ/ຢ: ຕ້ອງແຍກຕາມຄວາມໝາຍລາວເດີມ (ຢ = ຢືນ, ຢາ, ຢາກ / ຍ = ຍ່າງ, ຍາກ).

      8. ກົດໝາຍຕົວສະກົດ ແລະ ການສ້າງຄຳ (Morphology Strict Rule):
         - ຄຳສັບທຸກຄຳໃນພາສາລາວມີ "ຮູບແບບທີ່ຖືກຕ້ອງພຽງໜຶ່ງດຽວ (Single Source of Truth)". ❌ຫ້າມຕອບວ່າຖືກທັງສອງແບບເດັດຂາດ❌.
         - ຖ້າພົບຄຳທີ່ອອກສຽງຄືກັນແຕ່ຂຽນຕ່າງກັນ (Homophones) ເຊັ່ນ: "ອາດຊະຍາກຳ" ກັບ "ອາຊະຍາກຳ", ທ່ານຕ້ອງວິເຄາະຫາຮູບແບບທີ່ສົມບູນທີ່ສຸດ. (ກໍລະນີນີ້ຕ້ອງມີ "ດ" ສະກົດ). ຖ້າຜູ້ໃຊ້ພິມຜິດ ຫຼື ພິມມາປຽບທຽບກັນ ຕ້ອງຟັນທຸງເລືອກຄຳທີ່ຖືກພຽງຄຳດຽວ.
         - ຖ້າຜູ້ໃຊ້ພິມຜິດແມ່ນແຕ່ຕົວດຽວ (ເຊັ່ນ: ມີຕົວສະກົດເກີນມາ) ຕ້ອງປ່ຽນ status ເປັນ "CORRECTED" ແລະ ຕັດສິນວ່າຜິດສະເໝີ. ຫ້າມເດົາຄວາມໝາຍແລ້ວອະນຸລົມປ່ອຍຜ່ານເດັດຂາດ.
      9. ລະບົບຕ້ານການໂລເລ (Zero-Tolerance for Misspellings):
         - ເຖິງຜູ້ໃຊ້ຈະພິມມາພຽງ "ຄຳດຽວໂດດໆ" ຖ້າມັນຜິດຫຼັກການຂ້າງເທິງ ໃຫ້ຕອບ status: "CORRECTED" ແລ້ວແກ້ໄຂທັນທີ ຫ້າມອະນຸລົມປ່ອຍຜ່ານ.
         - ຫ້າມຕອບວ່າ PERFECT ຖ້າຄຳນັ້ນຍັງມີຈຸດຜິດພາດທາງໄວຍະກອນແມ່ນແຕ່ຕົວດຽວ.
      10. ຖານຂໍ້ມູນຄຳສັບບັງຄັບຂັ້ນເດັດຂາດ (Hardcoded Dictionary - ຫ້າມໂລເລ):
          - ຖ້າພົບຄຳເຫຼົ່ານີ້ ຕ້ອງຕັດສິນຕາມນີ້ 100% ຫ້າມອະນຸລົມໃຫ້ຄຳທີ່ຜິດເດັດຂາດ (ເຖິງຈະພິມມາພ້ອມກັນ ຫຼື ພິມໂດດໆກໍຕາມ):
          - [ອາດຊະຍາກຳ] ຖືກ / [ອາຊະຍາກຳ, ອາສະຍາກຳ] ຜິດ (ຕ້ອງມີ ດ ສະກົດສະເໝີ)
          - [ໂພຊະນາການ] ຖືກ / [ໂພສະນາການ, ໂພຊານາການ, ໂພສານາການ] ຜິດ (ໃຊ້ ຊ ຊ້າງ ແລະ ະ ສຽງສັ້ນ)
          - [ປັດຈຸບັນ] ຖືກ / [ປະຈຸບັນ] ຜິດ (ຕ້ອງມີ ດ ສະກົດ)
          - [ອະນຸຍາດ] ຖືກ / [ອານຸຍາດ] ຜິດ (ຫ້າມມີ ສະຫຼະ າ)
          - [ສັງເກດ] ຖືກ / [ສັງເກດການ, ສັງເກດຕິ] ຜິດ (ຖ້າໝາຍເຖິງການເບິ່ງ)
          - [ພາລະ] ຖືກ / [ພະລະ] ຜິດ (ຫ້າມມີ ສະຫຼະ ະ)
          - [ສາເຫດ] ຖືກ / [ສາຍເຫດ] ຜິດ (ຫ້າມມີ ຍ ສະກົດສະເໝີ)
          - [ນາຍົກ] ຖືກ / [ນາຍຍົກ] ຜິດ (ຫ້າມມີຕົວ ຍ ສະກົດ)
          - [ອັກຂະລະ] ຖືກ / [ອັກຄະລະ] ຜິດ (ໃຊ້ ຂ ເທົ່ານັ້ນ)
          - [ໂດຍກົງ] ຖືກ / [ໂດຍຕົງ] ຜິດ (ໃຊ້ ກ ເທົ່ານັ້ນ)
      ກົດລະບຽບການຕອບ (ຕ້ອງຕອບເປັນ JSON ທີ່ຖືກຕ້ອງ 100% ເທົ່ານັ້ນ ຫ້າມມີຂໍ້ຄວາມອື່ນປົນ):
      {
        "status": "PERFECT" (ຖ້າຖືກຕ້ອງໝົດທຸກຢ່າງແລ້ວ) ຫຼື "CORRECTED" (ຖ້າມີການແກ້ໄຂ),
        "corrected_text": "ຂໍ້ຄວາມທີ່ແກ້ໄຂໃຫ້ຖືກຕ້ອງແລ້ວທັງໝົດ (ຖ້າ status ເປັນ PERFECT ໃຫ້ສົ່ງຄ່າວ່າງ '')",
        "corrections": [
          {
            "wrong": "ຄຳສັບທີ່ຜິດ",
            "right": "ຄຳສັບທີ່ຖືກຕ້ອງ",
            "explanation": "ອະທິບາຍເຫດຜົນທາງໄວຍະກອນລາວລ້ວນໆ (ຫ້າມມີພາສາອັງກິດ ແລະ ອະທິບາຍໃຫ້ເປັນທຳມະຊາດ)."
          }
        ],
            "meaning": "ອະທິບາຍຄວາມໝາຍຂອງຄຳສັບນັ້ນຢ່າງລະອຽດ (ບັງຄັບໃຊ້ຄຳສັບລາວແທ້ 100% ຫ້າມໃຊ້ຄຳວ່າ ໂຫຍຫາ ຫຼື ສຳນວນໄທເດັດຂາດ. ຖ້າປະໂຫຍກຍາວເກີນໄປ ຫຼື ບໍ່ມີ ໃຫ້ປ່ອຍເປັນຄ່າວ່າງ '')"
      }`;

      const payload = {
        contents: [{ parts: [{ text: `ຂໍ້ຄວາມທີ່ຕ້ອງການກວດ ຫຼື ແປຄວາມໝາຍ: ${inputText}` }] }],
        systemInstruction: { parts: [{ text: systemPrompt }] },
        generationConfig: { 
          temperature: 0, 
          topK: 1, 
          topP: 0.1,
          responseMimeType: "application/json" 
        }
      };

      let result;
      let retries = 5;
      let delay = 1000;
      
      while (retries > 0) {
        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error?.message || 'ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບ API ໄດ້');
          }
          
          result = await response.json();
          break;
        } catch (e) {
          retries--;
          if (retries === 0) throw e;
          await new Promise(r => setTimeout(r, delay));
          delay *= 2;
        }
      }

      if (result && result.candidates && result.candidates[0].content.parts[0].text) {
        let responseText = result.candidates[0].content.parts[0].text.trim();
        
        const firstBrace = responseText.indexOf('{');
        const lastBrace = responseText.lastIndexOf('}');
        if (firstBrace !== -1 && lastBrace !== -1) {
            responseText = responseText.substring(firstBrace, lastBrace + 1);
        }

        try {
          const data = JSON.parse(responseText);
          
          if (data.status === 'PERFECT') {
            setIsPerfect(true);
          } else {
            setOutputText(data.corrected_text || '');
            setCorrections(data.corrections || []);
          }
          
          // ເກັບຄ່າຄວາມໝາຍ (ຖ້າ AI ສົ່ງມາ)
          if (data.meaning) {
            setMeaning(data.meaning);
          }

        } catch (parseError) {
          console.error("JSON Parse Error. Raw response:", responseText);
          throw new Error('ບໍ່ສາມາດອ່ານຜົນການກວດສອບໄດ້ (ຮູບແບບຂໍ້ມູນຜິດພາດ).');
        }
      } else {
         throw new Error('ບໍ່ສາມາດປະມວນຜົນໄດ້ ຫຼື ຮູບແບບການຕອບກັບບໍ່ຖືກຕ້ອງ.');
      }

    } catch (err) {
      setError(`ເກີດຂໍ້ຜິດພາດ: ${err.message}`);
      console.error(err);
    } finally {
      setIsLoading(false);
      setIsCooldown(true); // ເລີ່ມລັອກປຸ່ມ
      setTimeout(() => setIsCooldown(false), 5000); // ປົດລັອກຫຼັງຈາກ 5 ວິນາທີ
    }
  };

  const handleCopy = () => {
    if (!outputText) return;
    
    const textArea = document.createElement("textarea");
    textArea.value = outputText;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed', err);
    }
    document.body.removeChild(textArea);
  };

  const handleClear = () => {
    setInputText('');
    setOutputText('');
    setIsPerfect(false);
    setError('');
    setCorrections([]);
    setMeaning('');
  };

  return (
    <div className="min-h-screen bg-slate-50 py-8 px-4 sm:px-6 lg:px-8 flex flex-col items-center">
    
      {/* Font Injection */}
      <style dangerouslySetInnerHTML={{__html: `
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Lao:wght@300;400;500;600;700&display=swap');
        .font-lao {
          font-family: 'Phetsarath OT', 'Noto Sans Lao', sans-serif;
        }
      `}} />

      <div className="w-full max-w-4xl font-lao">
        
        {/* Header Section */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-800 mb-3 flex justify-center items-center gap-3">
            <CheckCircle className="text-blue-600 h-8 w-8 md:h-10 md:w-10" />
            ກວດໄວຍະກອນ ແລະ ວັດຈະນານຸກົມ ພາສາລາວ
          </h1>
          <p className="text-slate-500 text-sm md:text-base max-w-2xl mx-auto">
            ກວດສອບຄວາມຖືກຕ້ອງຂອງປະໂຫຍກ ແລະ ຄົ້ນຫາຄວາມໝາຍຂອງຄຳສັບພາສາລາວ. ຮອງຮັບທັງການກວດຄຳຜິດ ແລະ ການອະທິບາຍຄວາມໝາຍຢ່າງລະອຽດ.
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative">
          
          {/* Input Panel */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col h-full min-h-[350px]">
            <div className="bg-slate-100 px-4 py-3 border-b border-slate-200 flex justify-between items-center">
              <span className="font-semibold text-slate-700 flex items-center gap-2">
                ຂໍ້ຄວາມຕົ້ນສະບັບ
              </span>
              <button 
                onClick={handleClear}
                className="text-slate-400 hover:text-red-500 transition-colors flex items-center gap-1 text-sm font-medium"
                title="ລຶບຂໍ້ຄວາມ"
              >
                <Trash2 className="h-4 w-4" />
                ລຶບ
              </button>
            </div>
            <textarea
              className="w-full flex-grow p-4 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500/50 text-slate-700 text-lg leading-relaxed"
              placeholder="ປ້ອນຂໍ້ຄວາມເພື່ອໃຫ້ກວດໄວຍະກອນ ຫຼື ປ້ອນຄຳສັບເພື່ອຄົ້ນຫາຄວາມໝາຍ..."
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
            />
          </div>

          {/* Action Button (Mobile) */}
          <div className="md:hidden flex justify-center py-2">
            <button
              onClick={handleCheck}
              disabled={isLoading || isCooldown || !inputText.trim()}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full font-semibold shadow-md shadow-blue-500/30 transition-all active:scale-95 flex items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed w-full justify-center"
            >
              {isLoading ? (
                <><Loader2 className="animate-spin h-5 w-5" /> ກຳລັງປະມວນຜົນ...</>
              ) : (
                <><RefreshCw className="h-5 w-5" /> ກວດສອບ & ແປຄວາມໝາຍ</>
              )}
            </button>
          </div>

          {/* Output Panel */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col h-full min-h-[350px]">
             <div className="bg-slate-100 px-4 py-3 border-b border-slate-200 flex justify-between items-center">
              <span className="font-semibold text-slate-700">
                ຜົນການກວດສອບ
              </span>
              {(outputText && !isPerfect) && (
                <button 
                  onClick={handleCopy}
                  className={`${copied ? 'text-green-600' : 'text-blue-600'} hover:text-blue-700 transition-colors flex items-center gap-1 text-sm font-medium bg-blue-50 px-3 py-1 rounded-md`}
                >
                  {copied ? <CheckCircle className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
                  {copied ? 'ກັອບປີ້ແລ້ວ' : 'ກັອບປີ້'}
                </button>
              )}
            </div>

            <div className="p-4 flex-grow relative bg-slate-50/50">
              {isLoading && (
                <div className="absolute inset-0 bg-white/80 flex items-center justify-center z-10 backdrop-blur-sm">
                   <div className="flex flex-col items-center text-blue-600">
                      <Loader2 className="animate-spin h-10 w-10 mb-2" />
                      <span className="font-medium animate-pulse">ກຳລັງວິເຄາະຂໍ້ມູນ...</span>
                   </div>
                </div>
              )}

              {error && (
                <div className="bg-red-50 text-red-600 p-4 rounded-xl flex items-start gap-3 border border-red-100">
                  <AlertCircle className="h-6 w-6 shrink-0 mt-0.5" />
                  <p>{error}</p>
                </div>
              )}

              {isPerfect && !error && (
                <div className="flex flex-col items-center justify-center text-center p-6 animate-in fade-in zoom-in duration-300 h-full">
                  <div className="bg-green-100 text-green-600 p-4 rounded-full mb-4">
                    <CheckCircle className="h-12 w-12" />
                  </div>
                  <h3 className="text-2xl font-bold text-green-700 mb-2">ສຸດຍອດ!</h3>
                  <p className="text-lg text-green-600 font-medium">
                    ຂໍ້ຄວາມທີ່ທ່ານປ້ອນມາແມ່ນຖືກຕ້ອງແລ້ວ.
                  </p>
                </div>
              )}

              {outputText && !isPerfect && !error && (
                <div className="text-slate-800 text-lg leading-relaxed animate-in fade-in duration-300">
                  {outputText.split('\n').map((line, i) => (
                    <span key={i}>
                      {line}
                      <br/>
                    </span>
                  ))}
                </div>
              )}

              {!outputText && !isPerfect && !isLoading && !error && !meaning && (
                <div className="h-full flex flex-col items-center justify-center text-slate-400">
                  <RefreshCw className="h-12 w-12 mb-3 opacity-20" />
                  <p>ຜົນການກວດສອບ ຫຼື ຄວາມໝາຍຈະສະແດງຢູ່ບ່ອນນີ້</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Dictionary / Meaning Section (ສະແດງເມື່ອມີການແປຄວາມໝາຍ) */}
        {meaning && !isLoading && !error && (
          <div className="mt-8 bg-gradient-to-br from-indigo-50 to-blue-50 rounded-2xl shadow-sm border border-indigo-100 overflow-hidden animate-in fade-in slide-in-from-bottom-4 duration-500 w-full">
            <div className="bg-white/60 px-6 py-4 border-b border-indigo-100 flex items-center gap-3">
              <div className="bg-indigo-100 p-2 rounded-lg text-indigo-600">
                <BookText className="h-6 w-6" />
              </div>
              <h2 className="text-xl font-bold text-indigo-900">ຄວາມໝາຍ / ຄຳອະທິບາຍ</h2>
            </div>
            <div className="p-6">
              <div className="text-indigo-950 text-lg leading-relaxed">
                {meaning.split('\n').map((line, i) => (
                  <p key={i} className="mb-3 last:mb-0">{line}</p>
                ))}
              </div>
            </div>
          </div>
        )}
        
        {/* Corrections Detail Section */}
        {corrections.length > 0 && !isLoading && (
          <div className="mt-8 bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden animate-in fade-in slide-in-from-bottom-4 duration-500 w-full">
            <div className="bg-slate-100 px-6 py-4 border-b border-slate-200 flex items-center gap-3">
              <BookOpen className="text-blue-600 h-6 w-6" />
              <h2 className="text-xl font-bold text-slate-800">ຈຸດທີ່ກວດພົບຂໍ້ຜິດພາດ ແລະ ການປຽບທຽບ</h2>
            </div>
            <div className="p-6">
              <p className="text-slate-500 mb-6">ຮຽນຮູ້ຈາກຂໍ້ຜິດພາດເພື່ອພັດທະນາການຂຽນພາສາລາວໃຫ້ຖືກຕ້ອງຕາມຫຼັກໄວຍະກອນ.</p>
              
              <div className="space-y-4">
                {corrections.map((item, index) => (
                  <div key={index} className="flex flex-col md:flex-row md:items-center gap-4 bg-slate-50 p-4 rounded-xl border border-slate-100">
                    <div className="flex-1 flex flex-col sm:flex-row sm:items-center gap-3">
                      <div className="flex items-center gap-2 text-red-600 bg-red-100/50 px-3 py-2 rounded-lg border border-red-100 flex-1">
                        <XCircle className="h-5 w-5 shrink-0" />
                        <span className="font-medium line-through decoration-red-400/50">{item.wrong}</span>
                      </div>
                      
                      <div className="hidden sm:flex text-slate-300">
                        <ArrowRight className="h-5 w-5" />
                      </div>
                      <div className="sm:hidden text-slate-300 flex justify-center py-1">
                        <ArrowRight className="h-5 w-5 rotate-90" />
                      </div>

                      <div className="flex items-center gap-2 text-green-700 bg-green-100/50 px-3 py-2 rounded-lg border border-green-100 flex-1">
                        <CheckCircle className="h-5 w-5 shrink-0" />
                        <span className="font-medium">{item.right}</span>
                      </div>
                    </div>
                    
                    {item.explanation && (
                      <div className="flex-[1.5] text-slate-600 text-sm md:text-base border-t md:border-t-0 md:border-l border-slate-200 pt-3 md:pt-0 md:pl-4">
                        {item.explanation}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Desktop Check Button */}
        <div className="hidden md:flex justify-center mt-8">
          <button
            onClick={handleCheck}
            disabled={isLoading || isCooldown || !inputText.trim()}
            className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 rounded-full font-bold text-lg shadow-lg shadow-blue-500/30 transition-all hover:shadow-xl hover:-translate-y-1 active:scale-95 flex items-center gap-3 disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:hover:shadow-blue-500/30"
          >
            {isLoading ? (
              <><Loader2 className="animate-spin h-6 w-6" /> ກຳລັງປະມວນຜົນ...</>
            ) : (
              <><CheckCircle className="h-6 w-6" /> ກວດສອບ & ແປຄວາມໝາຍ</>
            )}
          </button>
        </div>

        {/* Footer info */}
        <div className="text-center mt-12 text-slate-400 text-sm">
           <p>ເພື່ອຄວາມຖືກຕ້ອງຕາມວັດຈະນານຸກົມພາສາລາວ</p>
        <p className="text-center text-slate-400 text-sm mt-2 max-w-2xl mx-auto leading-relaxed px-4">
              ລະບົບຂອງພວກເຮົາອາດຈະມີຂໍ້ຜິດພາດໄດ້. ຖ້າມີຂໍ້ບົກຜ່ອງໃດໆ, ພວກເຮົາຕ້ອງຂໍອະໄພມານະໂອກາດນີ້. ທ່ານສາມາດສົ່ງຂໍ້ຄວາມຫາພວກເຮົາໄດ້ໃນປຸ່ມ ສົ່ງຄຳຕິຊົມ ດ້ານລຸ່ມ ເພື່ອໃຫ້ພວກເຮົາໄດ້ນຳໄປປັບປຸງໃຫ້ດີຂຶ້ນ.
        </p>
          {/* ປຸ່ມເມນູດ້ານລຸ່ມ (ຈັດກາງ) */}
        <div className="flex justify-center items-center gap-4 mt-6 mb-2">
          
          {/* ປຸ່ມລິ້ງໄປເວັບກົດໝາຍລາວ */}
          <a
            href="https://lawlao.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm font-medium text-slate-600 bg-white hover:bg-slate-50 hover:text-blue-600 px-5 py-2.5 rounded-full shadow-sm border border-slate-200 transition-all"
          >
            <BookOpen className="w-4 h-4" />
            ກົດໝາຍລາວ
          </a>

          {/* ປຸ່ມສົ່ງຄຳຕິຊົມ */}
          <button
            onClick={() => setShowFeedbackModal(true)}
            className="flex items-center gap-2 text-sm font-medium text-slate-600 bg-white hover:bg-slate-50 hover:text-blue-600 px-5 py-2.5 rounded-full shadow-sm border border-slate-200 transition-all"
          >
            <MessageSquare className="w-4 h-4" />
            ສົ່ງຄຳຕິຊົມ
          </button>
          
        </div>
      </div>
          {/* ========================================= */}
        {/* ກ່ອງ Popup ສຳລັບຟອມຕິຊົມ */}
        {/* ========================================= */}
        {showFeedbackModal && (
          <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl w-full max-w-lg p-6 relative shadow-2xl animate-in fade-in zoom-in duration-200 overflow-y-auto max-h-[90vh]">
              
              <button 
                onClick={() => setShowFeedbackModal(false)}
                className="absolute top-4 right-4 text-slate-400 hover:text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-full p-1.5 transition-colors z-10"
              >
                <X className="w-5 h-5" />
              </button>

              <div className="bg-slate-50 px-6 py-4 border-b border-slate-200 rounded-t-2xl mt-2">
                <h3 className="text-md font-bold text-slate-700 flex items-center gap-2">
                  <MessageSquare className="w-5 h-5 text-blue-600" />
                  ສົ່ງຄຳຕິຊົມ ຫຼື ແນະນຳ
                </h3>
              </div>
              
              <div className="p-6">
                {feedbackStatus === 'success' ? (
                  <div className="bg-green-50 text-green-700 p-5 rounded-xl flex items-center gap-3 border border-green-100 font-medium">
                    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0" />
                    ສົ່ງຂໍ້ຄວາມສຳເລັດແລ້ວ! ຂອບໃຈສຳລັບຄວາມຄິດເຫັນເດີ.
                  </div>
                ) : (
                  <form onSubmit={handleFeedbackSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm text-slate-600 mb-1">ຊື່ຂອງທ່ານ</label>
                        <input type="text" required className="w-full p-3 border border-slate-200 rounded-xl outline-none focus:border-blue-500 bg-slate-50 transition-colors" placeholder="ພິມຊື່ ຫຼື ນາມແຝງ" value={feedbackData.name} onChange={e => setFeedbackData({...feedbackData, name: e.target.value})} />
                      </div>
                      <div>
                        <label className="block text-sm text-slate-600 mb-1">ອີເມວ ຫຼື ເບີໂທ</label>
                        <input type="text" className="w-full p-3 border border-slate-200 rounded-xl outline-none focus:border-blue-500 bg-slate-50 transition-colors" placeholder="ໄວ້ສຳລັບຕອບກັບ..." value={feedbackData.email} onChange={e => setFeedbackData({...feedbackData, email: e.target.value})} />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm text-slate-600 mb-1">ຂໍ້ຄວາມ <span className="text-red-500">*</span></label>
                      <textarea required className="w-full p-3 border border-slate-200 rounded-xl outline-none focus:border-blue-500 bg-slate-50 min-h-[100px] resize-y transition-colors" placeholder="ພິມຂໍ້ຄວາມແນະນຳ, ຕິຊົມ, ຫຼື ແຈ້ງບັນຫາ..." value={feedbackData.message} onChange={e => setFeedbackData({...feedbackData, message: e.target.value})} />
                    </div>
                    <button type="submit" disabled={isSubmittingFeedback} className="bg-slate-800 hover:bg-slate-900 text-white px-6 py-3 rounded-xl font-medium shadow-sm transition-all hover:shadow-md disabled:opacity-50 flex items-center gap-2 w-full justify-center">
                      {isSubmittingFeedback ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />}
                      {isSubmittingFeedback ? 'ກຳລັງສົ່ງຂໍ້ຄວາມ...' : 'ສົ່ງຂໍ້ຄວາມ'}
                    </button>
                    {feedbackStatus === 'error' && (
                      <p className="text-red-500 text-sm mt-2 flex items-center justify-center gap-1">
                        <AlertCircle className="w-4 h-4" /> ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໝ່.
                      </p>
                    )}
                  </form>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ສ່ວນຂອງ Copyright ລຸ່ມສຸດຂອງເວັບ */}
        <footer className="mt-12 pb-8 text-center text-sm text-slate-400 w-full">
          <p>&copy; {new Date().getFullYear()} Laogrammar.com. ສະຫງວນລິຂະສິດທຸກປະການ.</p>
        </footer>

      </div>
    </div>
  );
}

export default App;
